import React from 'react';
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars, faTable, faSearch, faSlidersH} from '@fortawesome/free-solid-svg-icons';
import {Button, Container} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import Content from "../../blocks/Content";
import {contains} from "../../../helpers/functions";
import Loader from "../../blocks/Loader";

function Startup(props) {
    const display_in_control = props.lamp.view_settings.display_in_control;
    const display_in_block = props.lamp.view_settings.display_in_block;
    const view_structures_length = props.lamp.view_settings.structures.length;
    const structures = [{value: 'All', label: props.t('All')}, ...props.structures_for_filter];
    const selected_structures = props.selected_structures;
    const setEmployees = (employeesArr) => {
        let employees = [];
        if (selected_structures.includes('All')) {
            employees = employeesArr;
        } else {
            employees = employeesArr.filter(el => selected_structures.includes(el.structure_id))
        };
        return employees
    };
    const employees = setEmployees(props.render_list_employees);

    return <div className={"Screen Startup"}>
            <Container>
                <div className="Startup-Actions d-flex mb-5">
                    <div className="input-group mr-4">
                        <div className="input-group-prepend">
                            <span className="Btn d-flex align-items-center display-9 mr-2 px-3">
                                <FontAwesomeIcon icon={faSearch}/>
                            </span>
                        </div>
                        <input type="text" onInput={(event) => props.search(event.currentTarget.value)} className="form-control display-9 text-center"
                               placeholder={props.t('Search by personal number or name')}/>
                    </div>
                    <div className="d-flex align-items-center">
                        <span className="mr-3 display-9">{props.t('View')}:</span>
                        <Button className={`Btn ${props.lamp.view_settings.template === 'list' ? 'Btn_success' : 'Btn_secondary'} h-100 display-9 px-3 mr-2`}
                                onClick={() => props.setTemplateLamp('list')}>
                            <FontAwesomeIcon icon={faBars}/>
                            </Button>
                        <Button className={`Btn ${props.lamp.view_settings.template === 'grid' ? 'Btn_success' : 'Btn_secondary'} h-100 display-9 mr-2 px-3`}
                                onClick={() => props.setTemplateLamp('grid')}>
                            <FontAwesomeIcon icon={faTable}/>
                        </Button>
                        <NavLink to="/lamp-settings" className="Btn Btn_success h-100 display-9 px-3 d-flex align-items-center">
                            <FontAwesomeIcon className="mr-3" icon={faSlidersH}/>
                            {props.t('Settings')}
                        </NavLink>
                    </div>
                </div>
            </Container>
            {!props.load.isLoading && props.lamp.view_settings.quick_switching && view_structures_length > 0 &&
                <Content className='container mh-25' style={{minHeight: 100}}>
                    <div className='w-100'>
                        <span className={`display-9 mr-3`}>{`${props.t('Show only')}:`}</span>
                        {structures.map(el => {
                            return <div onClick={()=>props.setSelectedStructures(el.value)} key={el.value} id={el.value}
                                        className={`border p-3 m-1 btn max-content display-9 ${contains(selected_structures, el.value) && `btn-success`}`}>
                                        {el.label}
                                    </div> })}
                    </div>
                </Content>}
            <Content className="container h-100">
                <Loader isLoading={props.load.isLoading} loadId="screen_startup" justifyContent="center" className="h-100">
                    {view_structures_length > 0
                        ? props.lamp.view_settings.template === 'grid'
                            ? <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-xl-5 row-cols-xxl-6 g-4">
                                {employees.map((emp) => {
                                    let breathalyzer_border = '';
                                    if (emp.hasOwnProperty('breathalyze_value') && emp.breathalyze_value === null) {
                                        breathalyzer_border = "";
                                    } else if (emp.hasOwnProperty('breathalyze_value')) {
                                        breathalyzer_border =  emp.breathalyze_value ? "breathalyze_success" : "breathalyze_danger";
                                    }
                                    return <div className="col mb-5" key={emp.uuid}>
                                            <div className={`card h-100 ${breathalyzer_border}`}>
                                                <NavLink to={`/card/${emp.uuid}`}>
                                                    <div className="card-body">
                                                        {(display_in_block.length === 0) && <p className="card-title display-6 text-center font-weight-bolder">{emp.number}</p>}
                                                        {contains(display_in_block, 'number') && <p className="card-title display-6 text-center font-weight-bolder">{emp.number}</p>}
                                                        {contains(display_in_block, 'title') && <p className="card-subtitle mb-2 display-9 text-center">{emp.title}</p>}
                                                        {contains(display_in_block, 'structure') && <p className="card-subtitle mb-2 display-10">{emp.structure}</p>}
                                                        {contains(display_in_block, 'position') && <p className="card-subtitle mb-2 display-10">{emp.position}</p>}
                                                    </div>
                                                </NavLink>
                                            </div>
                                           </div>})}
                              </div>
                            : <table className="table display-9 table-responsive table-hover">
                                <thead>
                                    <tr>
                                        {(display_in_control.length === 0) && <th scope="col">{props.t('Personal number')}</th>}
                                        {contains(display_in_control, 'number') && <th scope="col">{props.t('Personal number')}</th>}
                                        {contains(props.app.modules, 'breathalyze') && <th scope="col">{props.t('Breathalyzer')}</th>}
                                        {contains(display_in_control, 'title') && <th scope="col">{props.t('Full name')}</th>}
                                        {contains(display_in_control, 'structure') && <th scope="col">{props.t('Structure')}</th>}
                                        {contains(display_in_control, 'position') && <th scope="col">{props.t('Position')}</th>}
                                        {contains(display_in_control, 'passage_dt') && <th scope="col">{props.t('Training time')}</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                {employees.map((emp) => {
                                    let breathalyzer_bg = '';
                                    if (emp.hasOwnProperty('breathalyze_value') && emp.breathalyze_value === null) {
                                        breathalyzer_bg = "bg-secondary";
                                    } else if (emp.hasOwnProperty('breathalyze_value')) {
                                        breathalyzer_bg =  emp.breathalyze_value ? "bg-success" : "bg-danger";
                                    }
                                    return <tr key={emp.number}>
                                            {(display_in_control.length === 0) && <th scope="row"><NavLink to={`/card/${emp.uuid}`}>{emp.number}</NavLink></th>}
                                            {contains(display_in_control, 'number') && <th scope="row"><NavLink to={`/card/${emp.uuid}`}>{emp.number}</NavLink></th>}
                                            {contains(props.app.modules, 'breathalyze') &&
                                                <td><span className={`d-inline-block mb-2 p-4 top-0 translate-middle p-2 ${breathalyzer_bg} border border-light rounded-circle`}></span></td>}
                                            {contains(display_in_control, 'title') && <td><NavLink to={`/card/${emp.uuid}`}>{emp.title}</NavLink></td>}
                                            {contains(display_in_control, 'structure') && <td>{emp.structure}</td>}
                                            {contains(display_in_control, 'position') && <td>{emp.position}</td>}
                                            {contains(display_in_control, 'passage_dt') && <td>{new Date(Date.parse(emp.passage_dt.slice(0, -6))).toLocaleString()}</td>}
                                           </tr>})}
                                </tbody>
                            </table>
                        : <h1 className="card-title display-6 text-center font-weight-bolder text-danger">
                            {props.t("No structural unit")}
                          </h1>}
                    {employees.length === 0 && view_structures_length > 0 &&
                        <h1 className="card-title display-6 text-center font-weight-bolder text-danger">
                            {props.t("No filter unit")}
                        </h1>}
                </Loader>
            </Content>
           </div>
}

const mapStateToProps = (store) => {
    return {};
};

export default connect(mapStateToProps)(withTranslation()(Startup));